import { createSlice } from '@reduxjs/toolkit'

const loginInstructionSlice = createSlice({
  name: 'loginInstruction',
  initialState: {
    currentPage: 1
  },
  reducers: {
     setCurrentPageCount: (state, action) => {
      state.currentPage = action.payload; // <-- Reducer to update currentPage
    },
  },
});

export const { setCurrentPageCount } = loginInstructionSlice.actions;

export default loginInstructionSlice.reducer;